import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { NgOptimizedImage } from "@angular/common";
import {PaginatorComponent} from "../../../../layout/paginator/paginator.component";
import {TableSorterHeaderDirective} from "../../../../../directives/table-sorter/table-sorter-header.directive";
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {Offer} from '../../../../../models/offer';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {OfferService} from '../../../../../services/offer/offer.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import {RouterLink} from '@angular/router';
import {CountryService} from '../../../../../services/country/country.service';
import {IsGranted} from '../../../../../decorator/is-granted';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {TranslatePipe} from '@ngx-translate/core';
import {CurrencyPipe} from '../../../../../pipes/currency/currency.pipe';
import {CollapserComponent} from '../../../../layout/collapser/collapser.component';
import {CollapserItemComponent} from '../../../../layout/collapser-item/collapser-item.component';
import {ProductService} from '../../../../../services/product/product.service';
import {forkJoin} from 'rxjs';
import {Product} from '../../../../../models/product';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropdownSelectComponent} from '../../../../layout/dropdown-select/dropdown-select.component';
import {
  DropdownSelectOptionComponent
} from '../../../../layout/dropdown-select-option/dropdown-select-option.component';
import {AuthService} from '../../../../../services/auth/auth.service';
import {Country} from '../../../../../models/country';
import {ListFilters} from '../../../../../tools/list-filters/list-filters';
import {ListFilterService} from '../../../../../services/list-filter/list-filter.service';

@Component({
  selector: 'app-offer',
  imports: [
    PaginatorComponent,
    TableSorterHeaderDirective,
    TableSorterDirective,
    ConfirmDirective,
    RouterLink,
    NgOptimizedImage,
    IsGrantedDirective,
    TranslatePipe,
    CurrencyPipe,
    CurrencyPipe,
    CollapserComponent,
    CollapserItemComponent,
    ReactiveFormsModule,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    FormsModule
],
  templateUrl: './offer-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './offer-list.component.scss'
})
@IsGranted(['ROLE_API_OFFER_READ'])
@MetaTitle('Offers')
export class OfferListComponent implements OnInit {
  offers: Offer[] = [];
  products: Product[] = [];
  conversionTypeList: string[] = [];
  partnerAccountTypeList: string[] = [];
  countries: Country[] = [];
  paginator: Paginator = new Paginator(100);
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  filters: ListFilters;

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private offerService: OfferService,
    private productService: ProductService,
    private auth: AuthService,
    protected countryService: CountryService,
    protected listFilterService: ListFilterService
  ) {
    this.filters = listFilterService.createFilters({
      products: 'number[]',
      countries: 'string[]',
      conversionTypes: 'string[]',
      accountTypes: 'string[]',
    }, this.paginator, this.tableSorter);
  }

  ngOnInit(): void {
    this.loader.startLoading();

    forkJoin([
      this.productService.findAll({sort: 'name'}),
      this.countryService.findAll(),
      this.auth.getAsyncConfig(),
    ]).subscribe(([products, countries, config]) => {
      this.products = products;
      this.countries = countries;
      this.conversionTypeList = config?.data?.conversionTypeList ?? [];
      this.partnerAccountTypeList = config?.data?.partnerAccountTypeList ?? [];

      this.loader.stopLoading();
    });

    this.filters.init(() => this.fetchAll());
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    const params: any = {
      groups: 'product,advertiser'
    };

    const filters = this.filters.toParams();

    if (filters['products']) {
      params.products = filters['products'];
    }

    if (filters['accountTypes']) {
      params.targetAccountTypes = filters['accountTypes'];
    }

    if (filters['conversionTypes']) {
      params.conversionTypes = filters['conversionTypes'];
    }

    if (filters['countries']) {
      params.countries = filters['countries'].join(',');
    }

    this.offerService.findAll(params, this.paginator, this.tableSorter).subscribe((offers) => {
      this.offers = offers;

      this.loader.stopLoading();
    })
  }

  delete(offer: Offer): void {
    if (offer.id) {
      this.loader.startLoading();
      this.offerService.delete(offer.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Offer has been deleted');
        this.refresh();
      });
    }
  }
}
